
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/more",
      function () {
        return require("private-next-pages/mobiworkx/more.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/more"])
      });
    }
  